'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./box.scss');

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Box(_ref) {
  var align = _ref.align,
      className = _ref.className,
      direction = _ref.direction,
      justify = _ref.justify,
      xs = _ref.xs,
      sm = _ref.sm,
      m = _ref.m,
      lg = _ref.lg,
      flex = _ref.flex,
      grow = _ref.grow,
      props = _objectWithoutProperties(_ref, ['align', 'className', 'direction', 'justify', 'xs', 'sm', 'm', 'lg', 'flex', 'grow']);

  var classes = (0, _classnames2.default)('box', 'box--direction-' + direction, align && 'box--align-' + align, justify && 'box--justify-' + justify, xs && 'box--xs-' + xs, sm && 'box--sm-' + sm, m && 'box--m-' + m, lg && 'box--lg-' + lg, flex && 'box--flex', grow && 'box--grow', className);

  return _react2.default.createElement(
    'div',
    _extends({ className: classes }, props),
    props.children
  );
}

var columns = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

Box.propTypes = {
  align: _propTypes2.default.oneOf(['flex-start', 'center', 'flex-end', 'baseline', 'stretch']),
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  direction: _propTypes2.default.oneOf(['row', 'column', 'row-reverse', 'column-reverse']),
  flex: _propTypes2.default.bool,
  justify: _propTypes2.default.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around']),
  xs: _propTypes2.default.oneOf(columns),
  sm: _propTypes2.default.oneOf(columns),
  m: _propTypes2.default.oneOf(columns),
  lg: _propTypes2.default.oneOf(columns),
  grow: _propTypes2.default.bool
};

Box.defaultProps = {
  direction: 'row'
};

exports.default = Box;